import { Injectable } from '@angular/core';
import { JeevesOrderListConfigService } from 'gung-standard-jeeves';
import { TranslateService } from '@ngx-translate/core';
import { OrderService, SelectedCustomerService, MetadataService, CustomerService, Order } from 'gung-standard';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs';
import { ListLayout } from 'gung-list';
import { RefOrderCardListComponent } from '../../components/ref-order-card-list/ref-order-card-list.component';
import { DateUtilService } from 'gung-common';

@Injectable({
  providedIn: 'root'
})
export class RefJeevesOrderListConfigService extends JeevesOrderListConfigService {


  getItems(): Observable<Order[]> {
    return super.getItems().pipe(
      first(),
      map((orders: Order[]) => {
        // filter out Cancelled (90) orders
        return orders.filter(order => order.extra.oh.ordstat !== 90);
      }),
      map(orders => {
        for (const order of orders) {
          const ohfakttb: number = Number(order.extra.oh.ohfakttb) || 0;
          const ohordkostnad: number = Number(order.extra.oh.ohordkostnad) || 0;
          const ohordsum: number = Number(order.extra.oh.ohordsum) || 0;

          const divide = ohordkostnad / ohordsum;
          // Check if it's a division by 0, if it is and there is no margin, set marginPercentage as 0% else make percentage negative
          // If division is not by 0 then use normal value to calculate normal percentage
          const marginPercentage = ((!isFinite(divide) ? (ohfakttb !== 0 ? 2 : 1) : divide) - 1) * (-100);

          order.extra._gungMargin = ohfakttb;
          order.extra._gungMarginPercentage = marginPercentage;
        }

        return orders;
      })
    );
  }

  getLayouts(): ListLayout<Order>[] {
    return [
      {
        ...super.getLayouts()[0],
        getListItemComponent: () => RefOrderCardListComponent
      }
    ];
  }
}
